define.alias("shared/components/shared/platform-notice", "media/components/shared/platform-notice");